export enum OptionsWrapEnum {
  l = '1820px',
  m = '1512px',
  xm = '1177px',
  s = '600px',
  mobile = '490px',
  default = '-webkit-fill-available',
}

export enum OptionsRowType {
  Stub = 'stub',
  Type = 'type',
  Type1 = 'type1',
}
